import { SchoolType } from "./SchoolType"

export interface AlvisFile {
    sftpFilename: string
};

export interface AlvisSchoolUnit {
    id?: string
    displayName: string
    schoolUnitCode: string
    schoolType: SchoolType
    sftpFiles: AlvisFile[]
};

export interface CoreAlvisImportConfiguration {
    id: string
    moduleId: string
    sftpHostname?: string
    sftpUsername?: string
    sftpPassword?: string
    sftpFingerprint?: string
    startDateOffset: number
    includeSensitiveFields: AlvisSensitiveFiels
    alvisImportSchoolUnits: AlvisSchoolUnit[]
};


enum AlvisSensitiveFiels {
    Address = 1,
    CivicNo = 2,
    BirthDate = 16,
    PhoneNumber = 32,
    Sex = 64,
};

export const AlvisSensitiveFielsOptions: AlvisSensitiveFiels[] = [
    AlvisSensitiveFiels.Address,
    AlvisSensitiveFiels.CivicNo,
    AlvisSensitiveFiels.BirthDate,
    AlvisSensitiveFiels.PhoneNumber,
    AlvisSensitiveFiels.Sex,
];
